<template>
  <div class="vaccine-chooise">
    <div class="vaccine-chooise-title">请选择类别</div>
    <div @click="appointment()" class="vaccine-chooise-appointment">
      <img :src="require('@/assets/vaccine_appiontment_bg.png')" alt="" />
    </div>
    <div @click="record()" class="vaccine-chooise-record">
      <img :src="require('@/assets/vaccine_record_bg.png')" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openid: ""
    };
  },
  created() {
    this.openid = this.$route.query.openid;
  },
  methods: {
    appointment() {
      this.$router.push({
        name: "vaccine-form",
        query: {
          openid: this.openid
        }
      });
    },
    record() {
      this.$router.push({
        name: "vaccine-record",
        query: {
          openid: this.openid
        }
      });
    }
  }
};
</script>
<style lang="less">
.vaccine-chooise {
  &-title {
    margin-top: 3.09rem;
    color: #333;
    font-weight: 500;
    font-size: 2.06rem;
    text-align: center;
  }
  &-appointment {
    width: 84%;
    margin: 0 8%;
    margin-top: 2.13rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-record {
    width: 84%;
    margin: 0 8%;
    margin-top: 1.88rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
